<template>
  <div class="client-multi-check">
    <kt-autoselect
      :mode="props.mode"
      :label="props.label"
      :options="clientOptions"
      display-by="Company"
      value-by="CustomerNumber"
      :multiple="true"
      v-model="model"
      search-placeholder="Search clients..."
      :empty-text="props.emptyText"
      :on-refresh="handleRefresh"
      @change="handleChange"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, type PropType } from 'vue';
import { storeToRefs } from 'pinia';
import KtAutoselect from '@/components/UI/KtAutoselect.vue';
import { useClientStore } from '@/stores/ClientStore';
import type { ClientModel } from '@/models/ClientModel';

const props = defineProps({
  label: { 
    type: String, 
    default: 'Select Clients' 
  },
  mode: {
    type: String,
    default: "dropdown"
  },
  filter: {
    type: Function as PropType<(client: ClientModel) => boolean>,
    default: null
  },
  emptyText: {
    type: String,
    default: 'No Matching Clients'
  }
});

const emit = defineEmits<{
  change: [value: number[]];
}>();

const model = defineModel<number[]>({
  default: () => []
});

const clientStore = useClientStore();

// Bind directly to the store list so the dropdown updates reactively
// whenever the store (re)loads, and re-apply the filter prop automatically.
const { list } = storeToRefs(clientStore);

const clientOptions = computed<ClientModel[]>(() =>
  props.filter ? list.value.filter(props.filter) : list.value
);

// Load clients on mount (uses cache if available; only hits the API when empty)
onMounted(async () => {
  await clientStore.load();
});

const handleChange = (value: number[]) => {
  emit('change', value);
};

const handleRefresh = async () => {
  await clientStore.refresh();
};
</script>
